export const ALL_COUNTRIES_AND_RESORTS = 'All countries and resorts';
